import { cva, type VariantProps } from "class-variance-authority";
import SVG from "react-inlinesvg";

import PreloaderSVG from "@krea/customer-features/images/svg/preloader.svg";
import { cn } from "@krea/shared/utils";

const preloaderVariants = cva("", {
  variants: {
    size: {
      sm: "w-5",
      md: "w-6",
      lg: "w-12",
      xl: "w-14",
      xxl: "w-24",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

interface IPreloaderProps extends VariantProps<typeof preloaderVariants> {
  className?: string;
}

const Preloader = ({ className, size = "md" }: IPreloaderProps) => {
  return (
    <div className={cn("flex items-center justify-center", className)}>
      <div className={preloaderVariants({ size })}>
        <SVG className="h-auto w-full" src={PreloaderSVG} />
      </div>
    </div>
  );
};

export default Preloader;
